export const phoneNumValidation = [
    (input) => input.trim().length < 7 ? 'Your number should be at least 7 digits' : null,
    (input) => input.trim().length > 15 ? 'Your number should not be more than 15 digits' : null,
    (input) => /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(input) ? null : 'Enter a valid phone number',
]